<template>
    <div class="dwyc app-container">
      <div class="top" />
      <el-row type="flex" align="middle">
        <span class="demonstration">使用时间：</span>
        <el-date-picker
          v-model="datevalue"
          type="daterange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="yyyy-MM-dd"
          @change="getDateArr"
        />
        <el-button style="margin-left: 10px;" type="primary" @click="getData">统计</el-button>
      </el-row>
      <!-- <div class="statistics_title">{{ title }}</div> -->
      <div style="text-align: center;margin: 20px 0px 10px 0px;"><span class="statistics_title" style="text-align: center;">{{ title }}</span></div>
      <div class="echart">
        <EchartColumnar
          v-if="xAxis.length>0"
          :tooltip-format="tooltipFormat"
          :legend-align="{ location: 'bottom', align: 0 }"
          right="5%"
          left="5%"
          bottom="10%"
          bar-gap="0"
          bar-category-gap="1"
          :x-label-rotate="45"
          :y-units="yUnits"
          :x-unit="xUnit"
          :is-legend="true"
          :color="['#48c9b3','#a6d969']"
          :x-type-name="xTypeName"
          :color-by="'series'"
          :x-chart-num="2"
          :multiple-y-unit="true"
          :y-data="[count1,count2]"
          :x-data="xAxis"
          :chart-type="chartType"
/>
        <div v-else style="text-align:center;">
          <img src="images/w-imgs/nomessage.png"><br>
          <span style="font-size: var(--portalFontSize15);color:#dbdbdb">暂无数据</span>
        </div>
      </div>
      <div style="text-align:right">
        <el-button @click="toExport"><svg-icon icon-class="export" />导出</el-button>
      </div>
      <div>
        <data-table
          ref="dataTable"
          :list-tb="listTb3"
          :list-data="listData"
          :title-name="titleName"
          :radio="3"
          :show-summary="true"
        />
      </div>
    </div>
  </template>

<script>
import dataTable from './components/listTable'
import qs from 'qs'
const moment = require('moment')
export default {
    components: {
        dataTable
    },
    data() {
        return {
            xAxis: [], // x轴数据
            title: '证照借/使用统计', // 标题
            titleName: '证照借/使用统计', // 列表导出文件名
            listData: [], // 列表数据
            count1: [], // 借用次数数据
            count2: [], // 复印件使用次数数据
            // count3: [], // 总计
            xTypeName: [],
            datevalue: ['', ''], // 使用时间
            yUnit: { name: '次数', align: 'center', size: '13' },
            xUnit: { name: '证照名称', align: 'end', 'size': '13' },
            dataZoom: [{ type: 'inside', start: 0, end: 20 }],
            listTb3: [
                {
                    'prop': 'NAME',
                    'title': '证照名称',
                    'sortable': true,
                    'align': 'left'
                },
                {
                    'prop': 'CERT_TYPE',
                    'title': '证照类型',
                    'width': '120px',
                    'formatter': this.typeFormat,
                    'sortable': true,
                    'align': 'center'
                },
                {
                    'prop': 'total_NUMBER',
                    'width': '120px',
                    'title': '申请使用次数',
                    'sortable': true,
                    'align': 'center'
                }
            ],
            chartType: []
        }
    },
    created() {
        this.$bus.$emit('showNavSearch', false) // 取消右上搜索按钮
    },
    beforeDestroy() {
        this.$bus.$emit('showNavSearch', true) // 还原右上搜索按钮
    },
    mounted() {
        this.$nextTick(() => {
            const now = moment().format('YYYY-MM-DD')
            // const tow = moment().add(-180, 'days').format('YYYY-MM-DD')
            const tow = moment().add(-6, 'months').format('YYYY-MM-DD')
            console.log('1', now, '2', tow)
            this.datevalue = [tow, now]
            const nownow = moment().format('YYYY年MM月DD日')
            const towtow = moment().add(-180, 'days').format('YYYY年MM月DD日')
            console.log(typeof nownow)
            this.titleName = towtow + '至' + nownow + '证照借/使用统计'
            this.getData()
            console.log(this.datevalue)
        })
    },
    methods: {
        toExport() {
            console.log('this.listData', this.listData)
            const title = [
                { title: '序号', width: 60, align: 'center', colspan: 1, rowspan: 1 },
                { title: '证照名称', width: 100, align: 'left', colspan: 1, rowspan: 1 },
                { title: '证照类型', width: 120, align: 'center', colspan: 1, rowspan: 1 },
                { title: '申请次数', width: 120, align: 'center', colspan: 1, rowspan: 1 }
            ]
            const tbtitle = []
            tbtitle.push(title)

            const tbdata = []
            this.listData.forEach((list, listIndex) => {
                const row = [
                    { value: listIndex + 1, align: 'center', colspan: 1, rowspan: 1 },
                    { value: list.NAME, align: 'left', colspan: 1, rowspan: 1 },
                    { value: this.typeTable(list.CERT_TYPE), align: 'center', colspan: 1, rowspan: 1 },
                    { value: list.total_NUMBER, align: 'center', colspan: 1, rowspan: 1 }
                ]
                tbdata.push(row)
            })

            this.$http({
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                data: qs.stringify({
                    rows: JSON.stringify(tbdata),
                    titles: JSON.stringify(tbtitle),
                    fileName: '证照统计表'
                }),
                url: 'common/exportXlsFile?httpPort=' + location.port
            }).then((res) => {
                if (res.code === 'success') {
                    window.open(encodeURI('/apigw/' + res.body.xlsurl), '_blank')
                } else {
                    this.$alert(res.message, '操作提示', { type: 'error' })
                }
            })
        },
        tooltipFormat(params) {
            var val = params[0].name + '<br>'
            params.map((item, index) => {
                val += (item.marker + item.seriesName + '：' + item.value + '<br>')
            })
            return val
        },
        // 证照类型格式转换
        typeFormat(row, colum, cellValue, index) {
            if (cellValue === '1') return '营业执照'
            if (cellValue === '2') return '组织机构代码证'
            if (cellValue === '3') return '税务登记证'
            if (cellValue === '4') return '银行开户许可证'
        },
        typeTable(cellValue) {
            if (cellValue === '1') return '营业执照'
            if (cellValue === '2') return '组织机构代码证'
            if (cellValue === '3') return '税务登记证'
            if (cellValue === '4') return '银行开户许可证'
        },
        getData(val) {
            this.listData = []
            this.count1 = []
            this.count2 = []
            this.xAxis = []
            this.yUnits = [
                { name: '次数', align: 'center', 'size': '12', position: 'left', lineColor: '#000', minInterval: 1 }
                // { name: '数量', align: 'center', 'size': '12', position: 'right', lineColor: '#000' }
            ]
            this.xTypeName = [{ name: '借用次数', icon: 'roundRect' }, { name: '复印件使用', icon: 'roundRect' }]
            this.chartType = [{ type: 'bar', yAxisIndex: 0 }, { type: 'bar', yAxisIndex: 0 }]
            this.$http({
                url: 'zzgl/certInfo/listdataCount',
                method: 'post',
                params:
                      {
                          startDate: this.datevalue[0] ? '' + this.datevalue[0] + ' 00:00:00' : '',
                          endDate: this.datevalue[1] ? '' + this.datevalue[1] + ' 23:59:59' : ''
                      },
                contentType: 'application/x-www-form-urlencoded'
            }).then(res => {
                // this.titleName = '资产概况-资产概览'

                if (res.body.list && res.body.list.length > 0) {
                    this.listData = res.body.list
                    console.log('====', this.listData)
                    res.body.list.map((item, index) => {
                        this.count1.push(item.CERT_SHIFT_NUMBER)
                        this.count2.push(item.CERT_COPY_USE_NUMBER)
                        this.xAxis.push(item.NAME)
                    })
                    console.log(this.count1, this.count2, this.xAxis, '2131231')
                }
            })
        },
        // 更改时间
        getDateArr(data) {
            console.log('----', data)
            if (data) {
                this.datevalue = data
            } else {
                this.datevalue = ['', '']
            }
            this.titleName = moment(data[0]).format('YYYY年MM月DD日') + '至' + moment(data[1]).format('YYYY年MM月DD日') + '证照借/使用统计'
        }
    }
}
</script>

  <style scoped lang="scss">
  .dwyc {
    .top{
          display: flex;
          flex-direction: column;
      }
    .echart{
      height:300px;
      margin-bottom:20px;
    }
    .label{line-height: 36px;font-size: var(--portalFontSize14);width:84px;color: #606266;margin-left: 20px;}
  }
  /deep/.el-range-separator{
      width: 10% !important;
  }
  </style>
